import { beginTask, endTask } from 'redux-nprogress';
import { get } from 'lodash';
import { redirect, NOT_FOUND } from 'redux-first-router';
import debug from 'debug';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';
// import TEAMS_LANDING_VIEW from '../../TeamsLanding/module/teamsLanding';

const log = debug('huddle:app:news:');

export const STORE_KEY = 'news';
export const selectTeamState = state => state[STORE_KEY];

export const LOAD_TEAM_SUCCESS = `${STORE_KEY}/LOAD_TEAM_SUCCESS`;
export const LOAD_TEAM_ERROR = `${STORE_KEY}/LOAD_TEAM_ERROR`;
export const LOAD_TEAM_NEWS_SUCCESS = `${STORE_KEY}/LOAD_TEAM_NEWS_SUCCESS`;
export const LOAD_TAGS_NEWS_SUCCESS = `${STORE_KEY}/LOAD_TAGS_NEWS_SUCCESS`;
export const LOAD_TEAM_NEWS_ERROR = `${STORE_KEY}/LOAD_TEAM_NEWS_ERROR`;

export const CLEAR_TEAM = `${STORE_KEY}/CLEAR_TEAM`;
export const SET_TEAM_FORMULA = `${STORE_KEY}/SET_TEAM_FORMULA`;
export const SET_TEAM_SEASON = `${STORE_KEY}/SET_TEAM_SEASON`;
export const SET_TEAM_SUBVIEW = `${STORE_KEY}/SET_TEAM_SUBVIEW`;

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  newsCurrentPageNumber: null,
  newsNumPages: null,
  currentSubview: null,
  currentSeason: null,
  currentFormula: null,
  description: null,
  summary: null,
  wltRecord: null,
  news: null,
  roster: null,
  seasonStats: null,
  weeklyStats: null,
  position: '',
  teamDataHasLoaded: false,
  teamNewsHasLoaded: false,
  error: null,
};

const newsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_TEAM_FORMULA:
    case SET_TEAM_SEASON:
    case SET_TEAM_SUBVIEW:
      return { ...state, ...action.payload };
    case CLEAR_TEAM:
      return { ...state, ...initialState };
    case LOAD_TEAM_SUCCESS:
      return { ...state, ...action.payload, teamDataHasLoaded: true };
    case LOAD_TEAM_NEWS_SUCCESS:
      return { ...state, ...action.payload, teamNewsHasLoaded: true };
    case LOAD_TAGS_NEWS_SUCCESS:
      return { ...state, ...action.payload};
    case LOAD_TEAM_NEWS_ERROR:
    case LOAD_TEAM_ERROR:
      return { ...state, error: action.payload.error };
    default:
      return state;
  }
};

export default newsReducer;

// ------------------------------------
// Update season/formula/view
// ------------------------------------
export const setTeamFormula = formula => ({
  type: SET_TEAM_FORMULA,
  payload: { currentFormula: formula },
});

export const setTeamSeason = season => ({
  type: SET_TEAM_SEASON,
  payload: { currentSeason: season },
});

export const setTeamSubview = subview => ({
  type: SET_TEAM_SUBVIEW,
  payload: { currentSubview: subview },
});

// ------------------------------------
// Load Team Data
// ------------------------------------
export const clearTeam = () => ({
  type: CLEAR_TEAM,
});

export const loadTeamSuccess = ({ description }) => ({
  type: LOAD_TEAM_SUCCESS,
  payload: { description },
});

export const loadTeamError = error => ({
  type: LOAD_TEAM_ERROR,
  payload: { error },
});

export const loadTeamNewsSuccess = ({ news, total_pages, pageNumber }) => ({
  type: LOAD_TEAM_NEWS_SUCCESS,
  payload: { news, newsCurrentPageNumber: pageNumber, newsNumPages: total_pages },
});
export const loadTagsNewsSuccess = ({ tags}) => ({
  type: LOAD_TAGS_NEWS_SUCCESS,
  payload: {tags},
});

export const loadTeamNewsError = error => ({
  type: LOAD_TEAM_NEWS_ERROR,
  payload: { error },
});

export const loadTeamData = id => async (dispatch, getState) => {
  const state = getState();
  if (state.teams && state.teams[id]) {
    const { [id]: description } = state.teams;
    dispatch(loadTeamSuccess({ description }));
  } else {
    dispatch(loadTeamError('Team not found'));
  }
};


export const loadTeamNews = (id, pageSize, pageNumber, position, feed, league, tag) => async (dispatch, getState, { api }) => {
  if (league == 'none' || league == 'all') {
    try {
      dispatch(beginTask());
      const {news, total_pages} = await api.teams.teamNewsFiltered({id, pageSize, pageNumber, position, feed, tag});
      const {tags} = await api.teams.newsTags();
      dispatch(loadTagsNewsSuccess({tags}));
      dispatch(loadTeamNewsSuccess({news, total_pages, pageNumber}));
    } catch (error) {
      dispatch(loadTeamNewsError(error));
      log(error);
    } finally {
      dispatch(endTask());
    }
  } else {
    try {
      dispatch(beginTask());
      const { news, total_pages } = await api.teams.teamNewsCustom({id, pageSize, pageNumber, position, feed, league, tag });
      const {tags} =await api.teams.newsTags();
      dispatch(loadTagsNewsSuccess({ tags }));
      dispatch(loadTeamNewsSuccess({ news, total_pages, pageNumber }));
    } catch (error) {
      dispatch(loadTeamNewsError(error));
      log(error);
    } finally {
      dispatch(endTask());
    }
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const NEWS_VIEW = 'news/VIEW';
viewNames[NEWS_VIEW] = 'News';
routes[NEWS_VIEW] = {
  // Regex check to ensure id is a number
  path: '/nfl-fantasy-football-player-news/:id(\\d+)?/:teamName?/',
  thunk: async (dispatch, getState) => {
    const state = getState();
    const teamState = selectTeamState(state);
    let { id, selectedPosition, selectedNewsfeed, selectedLeague, selectedNewsTag } = state.location.payload;
    let { page, position, feed, league, tag } = selectQuery(state);
    if (!position) position = 'ALL';
    if (typeof feed == 'undefined') feed = '1';
    if (typeof league == 'undefined' &&  typeof selectedLeague == 'undefined') league = 'none';
    if (typeof tag == 'undefined') tag = 'ALL';
    if (!id) id = 0;
    if (!selectedPosition) selectedPosition = position;
    if (!selectedNewsfeed) selectedNewsfeed = feed;
    if (!selectedLeague) selectedLeague = league;
    if (!selectedNewsTag) selectedNewsTag = tag;
    let { [id]: description } = state.teams;
    // Lodash get() avoids error on accessing nested properties
    const defaultSeason = get(state, 'seasonLookup.current.stats.season');
    const { currentFormula, currentSeason } = teamState;
    const { defaultFormula } = state.formulas;
    if (!description) {
      description = {
        abbr: "NE",
        city: "All",
        color: "#cdcdcd",
        conference: "AFC",
        division: "East",
        id: 0,
        logo: {
          extra_large: "https://www.gannett-cdn.com/media/SMG/sports_logos/nfl-whitebg/110/NE.png",
          large: "https://www.gannett-cdn.com/media/SMG/sports_logos/nfl-whitebg/80/NE.png",
          medium: "https://www.gannett-cdn.com/media/SMG/sports_logos/nfl-whitebg/60/NE.png",
          small: "https://www.gannett-cdn.com/media/SMG/sports_logos/nfl-whitebg/40/NE.png",
          tiny: "https://www.gannett-cdn.com/media/SMG/sports_logos/nfl-whitebg/30/NE.png",
        },
        name: "Teams",
        slug: "new-england-patriots",
      }
      // const action = redirect({ type: NOT_FOUND });
      // return dispatch(action);
    }
    // These values can't be zero, safe to use short-circuit
    const formula = currentFormula || defaultFormula || 1;
    const year = currentSeason || defaultSeason || 2016;
    const pageSize = 30;
    const pageNumber = page || 1;
    dispatch(clearTeam());
    dispatch(loadTeamSuccess({ description }));
    dispatch(setTeamSubview('news-injuries'));
    dispatch(setTeamFormula(formula));
    dispatch(setTeamSeason(year));
    dispatch(loadTeamData(id));
    await Promise.all([
      dispatch(loadTeamNews(id, pageSize, pageNumber, position, selectedNewsfeed, selectedLeague,selectedNewsTag  )),
      dispatch(loadToolDescriptions()),
    ]);
  },
};

export const NEWS_VIEW_SUBVIEW = 'news/VIEW_SUBVIEW';
viewNames[NEWS_VIEW_SUBVIEW] = 'News';
routes[NEWS_VIEW_SUBVIEW] = {
  path: '/nfl-fantasy-football-player-news/:id(\\d+)/:teamName/',
  thunk: async (dispatch, getState) => {
    const state = getState();
    const teamState = selectTeamState(state);
    let { id, subview, selectedPosition, selectedNewsfeed, selectedLeague,selectedNewsTag } = state.location.payload;
    let { page, position, feed, league ,tag } = selectQuery(state);
    if (!position) position = 'ALL';
    if (typeof feed == 'undefined') feed = '1';
    if (typeof league == 'undefined' &&  typeof selectedLeague == 'undefined') league = 'none';
    if (!selectedPosition) selectedPosition = position;
    if (!selectedNewsfeed) selectedNewsfeed = feed;
    if (!selectedLeague) selectedLeague = league;
    if (!selectedNewsTag) selectedNewsTag = tag;
    // Lodash get() avoids error on accessing nested properties
    const defaultSeason = get(state, 'seasonLookup.current.stats.season');
    const { currentFormula, currentSeason, newsNumPages } = teamState;
    const currentId = get(state, 'team.description.id');
    const { defaultFormula } = state.formulas;
    // These values can't be zero, safe to use short-circuit
    const formula = currentFormula || defaultFormula || 1;
    const year = currentSeason || defaultSeason || 2016;
    const pageSize = 30;
    let pageNumber = page || 1;
    if (newsNumPages && pageNumber > newsNumPages) pageNumber = newsNumPages;
    if (pageNumber < 0) pageNumber = 1;
    if (subview === 'news-injuries') {
      if (currentId === id && typeof page === 'undefined') dispatch(setTeamSubview(subview));
      else if (currentId === id && !!page) await dispatch(loadTeamNews(id, pageSize, pageNumber, selectedPosition, selectedNewsfeed, selectedLeague,selectedNewsTag));
      else {
        dispatch(clearTeam());
        dispatch(setTeamSubview(subview));
        dispatch(setTeamFormula(formula));
        dispatch(setTeamSeason(year));
        await dispatch(loadTeamData(id));
        await Promise.all([
          dispatch(loadTeamNews(id, pageSize, pageNumber, selectedPosition, selectedNewsfeed, selectedLeague,selectedNewsTag)),
          dispatch(loadToolDescriptions()),
        ]);
      }
    } else {
      const action = redirect({ type: NEWS_VIEW, payload: { id } });
      return dispatch(action);
    }
  },
};

export const viewTeam = ({ id, teamName }) => ({
  type: NEWS_VIEW,
  payload: { id, teamName },
});

export const viewTeamSubview = ({ id, subview, teamName }) => ({
  type: NEWS_VIEW_SUBVIEW,
  payload: { id, subview, teamName },
});




// WEBPACK FOOTER //
// ./src/app/views/News/module/news.js